import { MultiSelect } from '@progress/kendo-react-dropdowns'
import styles from '../../styles/estrategiaAdaptacao/EstrategiaAdaptacao.module.scss'
import { Field, Form, FormElement, FormRenderProps } from '@progress/kendo-react-form'
import { Checkbox, CheckboxChangeEvent, Input, RadioGroup } from '@progress/kendo-react-inputs'
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { Error } from '@progress/kendo-react-labels';
import { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react'
import { acaoPlaneamento4, get, getEaRegistoAnalise, palavraschave } from '../../services/utils'
import { GET_ALL_TIPOLOGIA_OBRA_EXEC, GET_ALL_FAIXA_SALVAGUARDA_NIVEL, GET_VALOR_USO_DE_SOLO } from '../../utils/constants'
import { DateTimePicker } from '@progress/kendo-react-dateinputs'
import { FieldRenderProps } from '@progress/kendo-react-form';
import ReactGA from 'react-ga4';
import { Button } from '@progress/kendo-react-buttons';
import moment from 'moment';
import { filterBy } from '@progress/kendo-data-query';

type IProps = {
    idForm?: number
    initialValuesForm?: any
    viewMode?: boolean
    onChange?: any
    initialized?: any
}

interface FaixaSalvaguarda {
    id: number,
    descricao: string,
    ano: number,
    codigo: string;
}

interface Vus {
    id: number,
    descricao: string,
    tipo: number,
    estado: number,
    fonte_dados: number,
    data_registo: Date,
    tecnico_registo: number,
    ano_vus: number
}

interface SendDataEstrategiaAdaptacaoParametros {
    retirada: boolean,
    defesa: boolean,
    adaptacao: boolean,
    defesa_adaptacao: boolean,
    vus: number[],
    salvaguarda_faixa: number[],
    cod_salvaguarda_faixa: any,
    lstTipologiasObra: number[],
    custo_adaptacao_edificio?: number,
    custo_demolicao?: number,
    custo_renaturalizacao?: number,
    dt_periodo_analise_de?: Date,
    dt_periodo_analise_para?: Date,
    atualizacao_preco?: number,
    atualizacao_preco_valor?: number,
    atualizacao_preco_ano?: Date,
    [key: string]: any;
}

const EstrategiaAdaptacaoParametros = forwardRef(({
    idForm, initialValuesForm, viewMode, onChange, initialized
}: IProps, ref: React.Ref<any>) => {

    const formRef = useRef<Form>(null);
    const btnSubmitRef = useRef<Button>(null);

    const freezerValues = useRef<any>(null);

    let errorMessage = "";

    const prefixFaixa = "faixa_salvaguarda_";
    const prefixVus = "vus_";

    const getChecboxName = (prefix: string, nameElement: string) => `${prefix}${nameElement}`

    const [initialize, setInitialize] = useState(false);
    const [formKey, setFormKey] = useState(1);
    const [initialValues, setInitialValues] = useState<any>({})

    const [tipologiasObraExecucao, setTipologiasObraExecucao] = useState<any>()
    const [listFaixaSalvaguarda, setListFaixaSalvaguarda] = useState<any>([])
    const [listVus, setListVus] = useState<any>([])

    const getTipologiasObraExecucao = () => get<any>(GET_ALL_TIPOLOGIA_OBRA_EXEC);

    const getFaixaSalvaguarda = () => get<FaixaSalvaguarda[]>(GET_ALL_FAIXA_SALVAGUARDA_NIVEL);

    const getVus = () => get<Vus[]>(GET_VALOR_USO_DE_SOLO);

    type combosKeys = "acaoPlaneamento4";

    const [combos, setCombos] = useState<any>({
        acaoPlaneamento4
    })

    const setDataOption: Record<combosKeys, { setFn: any, data: any[] }> = {
        acaoPlaneamento4: { setFn: setCombos, data: acaoPlaneamento4 },
    };

    const filterCombo_Multiselect = (e: any, tipoCombo: combosKeys) => {
        const { setFn, data } = setDataOption[tipoCombo];
            setFn({
                ...combos,
                [tipoCombo]: filterBy(data?.slice()??[], e.filter)
            }
        );
    }
    /**
     * Load combobox data
     **/
    useEffect(() => {
        postMessage({ type: "showLoader" }, "*");

        Promise.all([getTipologiasObraExecucao(), getFaixaSalvaguarda(), getVus()])
            .then(result => {
                setTipologiasObraExecucao(result[0]);
                setListFaixaSalvaguarda(result[1]);
                setListVus(result[2]);
            })
            .catch(error => {
                console.error('Tudos os dados não puderam ser carregados:', error);
            })
            .finally(() => {
                postMessage({ type: "hideLoader" }, "*");
            });
    }, [])

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "/EstrategiaAdaptacaoParametros" });

        if (initialValues) {
            onChange();
        }
        initialized(idForm);
    }, []);


    /**
     * Define exposed component functions
     **/
    useImperativeHandle(ref, () => ({
        getValues: () => getFormValues(),
        isValid: () => checkIsValid(),
        isDirty: () => {

            /*if ((typeof formRef?.current?.modified == 'boolean' && formRef?.current?.modified) || (typeof formRef?.current?.modified == 'object' && Object.keys(formRef?.current?.modified).length > 0)) {
                return true;
            }*/

            const formValues: any = getFormValues();

            if (JSON.stringify(formValues) != JSON.stringify(initialValues)) {
                if ((typeof formRef?.current?.modified == 'boolean' && formRef?.current?.modified) || (typeof formRef?.current?.modified == 'object' && Object.keys(formRef?.current?.modified).length > 0)) {
                    return true;
                }
            }

            return false;

            /*if (initialValuesForm) {
                for (const key in formValues) {
                    if (formValues[key] && Array.isArray(formValues[key])) {
                        if (initialValuesForm[key] && Array.isArray(initialValuesForm[key])) {
                            if (formValues[key].length == initialValuesForm[key].length) {
                                const findItem = formValues[key].some((item: number) => {
                                    const index = initialValuesForm[key].findIndex((itemV: number) => itemV == item)
                                    return index < 0;
                                });

                                if (findItem) {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        } else {
                            return true;
                        }
                    } else {
                        if (formValues[key] != initialValuesForm[key]) {
                            return true
                        }
                    }
                }
            } else {
                return JSON.stringify(formValues) != JSON.stringify(initialValues);
            }

            return false;*/
        },
        showInvalidMessage: () => {

            btnSubmitRef.current?.element?.click();

            if (errorMessage && errorMessage != "") {
                postMessage({ type: 'errorMsg', value: { message: errorMessage } }, '*');
            } else {
                if (!checkIsValid()) {
                    postMessage({ type: 'errorMsg', value: { message: errorMessage } }, '*');
                }
            }
        },
        freezerValues: () => {
            const formValues: any = getFormValues();
            setInitialValues(formValues);
        }
    }));

    /**
     * Initialize form values
     **/
    const createInitialValuesObj = () => {

        if (!initialize) {

            const initialValuesObj: any = {};
            const sampleObj: SendDataEstrategiaAdaptacaoParametros = {
                retirada: false,
                defesa: false,
                adaptacao: false,
                defesa_adaptacao: false,
                vus: [],
                salvaguarda_faixa: [],
                cod_salvaguarda_faixa: {},
                lstTipologiasObra: [],
                custo_adaptacao_edificio: 0,
                custo_demolicao: 0,
                custo_renaturalizacao: 0,
                dt_periodo_analise_de: undefined,
                dt_periodo_analise_para: undefined,
                atualizacao_preco: 0,
                atualizacao_preco_valor: undefined,
                atualizacao_preco_ano: undefined
            };

            for (const key in initialValuesForm) {
                if (initialValuesForm[key] != null && initialValuesForm[key] != undefined && key in sampleObj) {
                    switch (key) {
                        /*case "vus":
                            initialValuesForm[key].map((item: number) => {
                                initialValuesObj[`${prefixVus}${item}`] = true;
                            })
                            break;
                        case "salvaguarda_faixa":
                            initialValuesForm[key].map((item: number) => {
                                initialValuesObj[`${prefixFaixa}${item}`] = true;
                            })
                            break;*/
                        case "lstTipologiasObra":
                            initialValuesObj[key] = acaoPlaneamento4.filter((tipoObra) => {
                                return initialValuesForm?.lstTipologiasObra.some((selTipoObra: { id: any; }) => tipoObra.id == selTipoObra)
                            });
                            break;
                        case "dt_periodo_analise_de":
                        case "dt_periodo_analise_para":
                        case "atualizacao_preco_ano":
                            if (initialValuesForm[key] instanceof Date) {
                                initialValuesObj[key] = initialValuesForm[key];
                            }
                            else {
                                if (typeof initialValuesForm[key] == 'string') {
                                    initialValuesObj[key] = moment(initialValuesForm[key]).toDate();
                                } else {
                                    initialValuesObj[key] = initialValuesForm[key].toDate();
                                }
                            }
                            break;
                        default:
                            initialValuesObj[key] = initialValuesForm[key];
                    }
                }
            }

            if (!("atualizacao_preco" in initialValuesObj)) {
                initialValuesObj["atualizacao_preco"] = 0;
            }
            if (!("custo_adaptacao_edificio" in initialValuesObj)) {
                initialValuesObj["custo_adaptacao_edificio"] = 0;
            }
            if (!("custo_demolicao" in initialValuesObj)) {
                initialValuesObj["custo_demolicao"] = 0;
            }
            if (!("custo_renaturalizacao" in initialValuesObj)) {
                initialValuesObj["custo_renaturalizacao"] = 0;
            }

            setInitialValues(initialValuesObj);
            setInitialize(true);
            setFormKey(formKey + 1);
        }
    }

    createInitialValuesObj();

    /**
     * Return form values
     **/
    const getFormValues = () => {
        if (formRef.current) {

            const sendData: SendDataEstrategiaAdaptacaoParametros = {
                retirada: false,
                defesa: false,
                adaptacao: false,
                defesa_adaptacao: false,
                vus: [],
                salvaguarda_faixa: [],
                cod_salvaguarda_faixa: {},
                lstTipologiasObra: []
            };

            const formData: any = formRef?.current?.values;

            for (const key in formData) {
                if (formData[key] != undefined && formData[key] != null) {
                    if (key.startsWith(prefixFaixa)) {
                        if (formData[key]) {
                            sendData.salvaguarda_faixa?.push(parseInt(key.slice(prefixFaixa.length)));
                        }
                    } else if (key.startsWith(prefixVus)) {
                        if (formData[key]) {
                            sendData.vus?.push(parseInt(key.slice(prefixVus.length)));
                        }
                    } else if (key === "atualizacao_preco_ano") {
                        sendData["atualizacao_preco_ano"] = new Date(
                            parseInt(formData["atualizacao_preco_ano"]), 
                            1, 
                            1 
                        );
                    } else {
                        if (key == 'salvaguarda_faixa') {

                            sendData['cod_salvaguarda_faixa'] = {};

                            formData[key].map((idFaixa: number) => {
                                listFaixaSalvaguarda.some((faixaItem: any) => {
                                    if (faixaItem.id == idFaixa) {
                                        sendData['cod_salvaguarda_faixa'][parseInt(faixaItem.codigo)] = true;
                                        return true;
                                    }
                                    return false;
                                });
                            });
                        }
                        sendData[key] = formData[key];
                    }
                }
            }

            return sendData;
        }
        return null;
    }

    /**
     * Verify if form is valid
     **/
    const checkIsValid = () => {

        errorMessage = "";

        const formValues: any = getFormValues();

        if (formValues.retirada || formValues.defesa || formValues.adaptacao || formValues.defesa_adaptacao) {
            if (formValues.salvaguarda_faixa.length == 0) {
                errorMessage = "A faixas de salvaguarda é obrigatória."
            } else {
                if (formValues.vus.length == 0) {
                    errorMessage = "A camada VUS é obrigatória."
                } else {
                    if (!formRef?.current?.isValid()) {
                        errorMessage = "Existem campos inválidos."
                    }
                    /*if (formValues.adaptacao || formValues.defesa_adaptacao) {
                        if (!formValues.custo_adaptacao_edificio) {
                            errorMessage = "O campo Custo de adaptação de edifício é obrigatório."
                            return false;
                        }
                    }
                    if (formValues.retirada) {
                        if (!formValues.custo_demolicao) {
                            errorMessage = "O campo Custo de demolição é obrigatório."
                            return false;
                        }
                        if (!formValues.custo_renaturalizacao) {
                            errorMessage = "O campo Custo de renaturalização é obrigatório."
                            return false;
                        }
                    }*/
                }
            }
        } else {
            errorMessage = "Verifique os campos obrigatórios."
        }

        return errorMessage == "";
    }

    const handelSumit = () => { return true };


    const validationRules = {
        greaterThanZero: (value: number) => value > 0 ? "" : "O valor deve ser maior o a 0",
        greaterThanOrEqualTo: (value: number, toCompare: number) => {
            return value >= toCompare ? "" : `O valor deve ser maior ou igual a ${toCompare}`
        },
        checkboxRequiredField: (value: any) => {
            return value && value.length > 0 ? "" : "Deve selecionar pelo menos uma opção.";
        },
        requiredField: (value: any) => value == undefined || value == null || (typeof value == 'string' && value.trim() == "") ? "Campo obrigatório." : ""
    }

    interface CheckboxOption {
        label: string;
        value: string;
    }

    interface CheckboxGroupProps extends FieldRenderProps {
        value: string[];
        options: [];
        attrValue: string;
        attrLabel: string;
    }

    const CheckboxGroup: React.FC<CheckboxGroupProps> = (field) => {

        const [selectedValues, setSelectedValues] = useState<string[]>(field.value || []);

        const handleChange = (event: any) => {
            const value = event.target.name.startsWith(field.name) ? parseInt(event.target.name.slice(field.name.length + 1)) : event.target.name;

            const newSelectedValues = event.target.value
                ? [...selectedValues, value]
                : selectedValues.filter(v => v !== value);

            setSelectedValues(newSelectedValues);
            field.onChange({ value: newSelectedValues });
        };

        const listOptions = field.options.map((option) => {
            return {
                label: option[field.attrLabel],
                value: option[field.attrValue]
            }
        });

        return (
            <div>
                {listOptions.map(option => (
                    <div key={option.value}>
                        <Checkbox
                            name={`${field.name}_${option.value}`}
                            disabled={field.disabled}
                            value={option.value}
                            label={option.label}
                            onChange={handleChange}
                            checked={selectedValues.includes(option.value)}
                        />
                    </div>
                ))}
                {field && field.visited && field.error && <Error>{field.error}</Error>}
            </div>
        );
    };

    return (
        <Form
            key={formKey}
            ref={formRef}
            initialValues={initialValues}
            onSubmit={handelSumit}
            render={(formRenderProps) => (
                <FormElement>
                    <div className={`${styles.form} ${styles.removeScrollDuplicado}`}>
                        <span style={{ marginLeft: '08px' }}>Os campos com simbolo * (asterisco) são de preenchimento obrigatório</span>

                        <fieldset>
                            <legend>
                                <span className={styles.fieldsetTitulo}>Componentes de análise *</span>
                            </legend>
                            <div className={styles.espacoVerticalFieldSet}>
                                <div style={{ marginLeft: '08px' }}>
                                    <div>
                                        <Field
                                            name="retirada"
                                            label="Retirada"
                                            component={Checkbox}
                                            disabled={viewMode}
                                            defaultChecked={initialValues?.retirada ?? false}
                                        />
                                    </div>
                                    <div>
                                        <Field
                                            name="defesa"
                                            label="Defesa"
                                            component={Checkbox}
                                            disabled={viewMode}
                                            defaultChecked={initialValues?.defesa ?? false}
                                        />
                                    </div>
                                    <div>
                                        <Field
                                            name="adaptacao"
                                            label="Adaptação"
                                            component={Checkbox}
                                            disabled={viewMode}
                                            defaultChecked={initialValues?.adaptacao ?? false}
                                        />
                                    </div>
                                    <div>
                                        <Field
                                            name="defesa_adaptacao"
                                            label="Defesa + adaptação"
                                            component={Checkbox}
                                            disabled={viewMode}
                                            defaultChecked={initialValues?.defesa_adaptacao ?? false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </fieldset>

                        <fieldset>
                            <legend>
                                <span className={styles.fieldsetTitulo}>Seleção de faixas de salvaguarda *</span>
                            </legend>

                            <div className={styles.espacoVerticalFieldSet}>
                                <div style={{ marginLeft: '08px' }}>
                                    <Field
                                        name="salvaguarda_faixa"
                                        component={CheckboxGroup}
                                        attrValue="id"
                                        attrLabel="descricao"
                                        disabled={viewMode}
                                        options={listFaixaSalvaguarda}
                                        validator={validationRules.checkboxRequiredField}
                                    />
                                </div>
                            </div>
                        </fieldset>

                        <fieldset>
                            <legend>
                                <span className={styles.fieldsetTitulo}>Seleção de camada VUS *</span>
                            </legend>

                            <div className={styles.espacoVerticalFieldSet}>
                                <div style={{ marginLeft: '08px' }}>
                                    <Field
                                        name="vus"
                                        component={CheckboxGroup}
                                        attrValue="id"
                                        attrLabel="descricao"
                                        disabled={viewMode}
                                        options={listVus}
                                        validator={validationRules.checkboxRequiredField}
                                    />
                                </div>
                            </div>
                        </fieldset>

                        {formRenderProps?.valueGetter("defesa") || formRenderProps?.valueGetter("defesa_adaptacao") ?
                            <fieldset>
                                <legend>
                                    <span className={styles.fieldsetTitulo}>Tipologias de ações</span>
                                </legend>
                                <div className={styles.espacoVerticalFieldSet}>
                                    <div>
                                        <Field
                                            name="lstTipologiasObra"
                                            label="Tipologias de ações"
                                            component={MultiSelect}
                                            textField={'descricao'}
                                            filterable={true}
                                            onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'acaoPlaneamento4')}}
                                            data={combos?.acaoPlaneamento4}
                                            disabled={viewMode}
                                        />
                                    </div>
                                </div>
                            </fieldset>
                            : <></>
                        }

                        {formRenderProps?.valueGetter("adaptacao") || formRenderProps?.valueGetter("defesa_adaptacao") ?
                            <fieldset>
                                <legend> &nbsp;
                                    <span className={styles.fieldsetTitulo}>Custo de adaptação de edifício [€/m<sup>2</sup>] *</span>{' '}
                                </legend>
                                <div className={styles.espacoVerticalFieldSet}>
                                    <div className={styles.fields}>
                                        <div>
                                            <Field
                                                name="custo_adaptacao_edificio"
                                                label="Custo de adaptação de edifício *"
                                                component={Input}
                                                disabled={viewMode}
                                                type={'number'}
                                                validator={(value) => validationRules.requiredField(value) || validationRules.greaterThanZero(value)}
                                                onKeyDown={(evt: any) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                            />
                                            {formRenderProps.visited && formRenderProps.errors.custo_adaptacao_edificio && (
                                                <Error>{formRenderProps.errors.custo_adaptacao_edificio}</Error>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            : <></>
                        }

                        {formRenderProps?.valueGetter("retirada") ?
                            <fieldset>
                                <legend> &nbsp;
                                    <span className={styles.fieldsetTitulo}>Custo de demolição [€/m<sup>2</sup>] *</span>{' '}
                                </legend>
                                <div className={styles.espacoVerticalFieldSet}>
                                    <div className={styles.fields}>
                                        <div>
                                            <Field
                                                name="custo_demolicao"
                                                label="Custo de demolição *"
                                                component={Input}
                                                disabled={viewMode}
                                                type={'number'}
                                                validator={(value) => validationRules.requiredField(value) || validationRules.greaterThanOrEqualTo(value, 0)}
                                                onKeyDown={(evt: any) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                            />
                                            {formRenderProps.visited && formRenderProps.errors.custo_demolicao && (
                                                <Error>{formRenderProps.errors.custo_demolicao}</Error>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            : <></>
                        }

                        {formRenderProps?.valueGetter("retirada") ?
                            <fieldset>
                                <legend> &nbsp;
                                    <span className={styles.fieldsetTitulo}>Custo de renaturalização [€/m<sup>2</sup>] *</span>{' '}
                                </legend>
                                <div className={styles.espacoVerticalFieldSet}>
                                    <div className={styles.fields}>
                                        <div>
                                            <Field
                                                name="custo_renaturalizacao"
                                                label="Custo de renaturalização *"
                                                component={Input}
                                                disabled={viewMode}
                                                type={'number'}
                                                validator={(value) => validationRules.requiredField(value) || validationRules.greaterThanOrEqualTo(value, 0)}
                                                onKeyDown={(evt: any) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                            />
                                            {formRenderProps.visited && formRenderProps.errors.custo_renaturalizacao && (
                                                <Error>{formRenderProps.errors.custo_renaturalizacao}</Error>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            : <></>
                        }

                        <fieldset>
                            <legend> &nbsp;
                                <span className={styles.fieldsetTitulo}>Período de análise</span>{' '}
                            </legend>
                            <div className={styles.espacoVerticalFieldSet}>
                                <div className={styles.fields}>
                                    <div>
                                        <Field
                                            name="dt_periodo_analise_de"
                                            label="De"
                                            format="dd/MM/yyyy"
                                            component={DateTimePicker}
                                            disabled={viewMode}
                                        />
                                    </div>
                                    <div>
                                        <Field
                                            name="dt_periodo_analise_para"
                                            label="Até"
                                            format="dd/MM/yyyy"
                                            component={DateTimePicker}
                                            disabled={viewMode}
                                        />
                                    </div>
                                </div>
                            </div>
                        </fieldset>

                        <fieldset>
                            <legend>
                                <span className={styles.fieldsetTitulo}>Atualização de preços</span>{' '}
                            </legend>
                            <div className={styles.espacoVerticalFieldSet}>
                                <div className={styles.fields}>
                                    <Field
                                        name="atualizacao_preco"
                                        label={"Atualização de preços"}
                                        id={'atualizacao_preco'}
                                        layout={'horizontal'}
                                        component={RadioGroup}
                                        disabled={viewMode}
                                        data={[
                                            { label: "Preços atuais (IPC)", value: 0 },
                                            { label: "Preço por índice manual", value: 1 },
                                            //{ label: "Atual", value: 2 },
                                            { label: "Preço para ano de referência (IPC)", value: 3 },
                                            { label: "Sem atualização de preços", value: 4 }
                                        ]}
                                        defaultValue={0}
                                    />
                                </div>

                                {formRenderProps?.valueGetter("atualizacao_preco") == 1 ?
                                    <div>
                                        <Field
                                            name="atualizacao_preco_valor"
                                            label="Valor de índice manual"
                                            component={Input}
                                            disabled={viewMode}
                                            validator={(value) => validationRules.requiredField(value) || validationRules.greaterThanOrEqualTo(value, 0)}
                                        />
                                        {formRenderProps.visited && formRenderProps.errors.atualizacao_preco_valor && (
                                            <Error>{formRenderProps.errors.atualizacao_preco_valor}</Error>
                                        )}
                                    </div>
                                    : <></>}
                                {formRenderProps?.valueGetter("atualizacao_preco") == 3 ?
                                    <div>
                                      <Field
                                        name="atualizacao_preco_ano"
                                        label="Ano de atualização de preço"
                                        component={Input}
                                        type="number"
                                        disabled={viewMode}
                                        validator={validationRules.requiredField}
                                    />
                                    </div>
                                    : <></>}
                            </div>
                        </fieldset>
                        <Button
                            ref={btnSubmitRef}
                            disabled={!formRenderProps.allowSubmit}
                            style={{
                                'visibility': 'hidden',
                                'height': '0px',
                                'width': '0px',
                                'padding': '0px',
                                'border': '0px'
                            }}
                            onClick={formRenderProps.onSubmit}
                        ></Button>
                    </div>
                </FormElement>
            )}
        />
    )
});

export default EstrategiaAdaptacaoParametros;